import React from "react";
import PropTypes from "prop-types";

const FuzzySearchInput = ({
  value,
  onValueChange,
  onChange,
  className,
  placeholder,
  ariaLabel,
  name,
  autoComplete,
  type,
}) => {
  const handleChange = (e) => {
    if (onChange) onChange(e);
    if (onValueChange) onValueChange(e.target.value, e);
  };

  return (
    <input
      className={className}
      type={type}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      aria-label={ariaLabel}
      autoComplete={autoComplete}
    />
  );
};

FuzzySearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  type: PropTypes.string,
};

FuzzySearchInput.defaultProps = {
  onValueChange: undefined,
  onChange: undefined,
  className: "",
  placeholder: "Search",
  ariaLabel: "Search",
  name: undefined,
  autoComplete: "none",
  type: "text",
};

export default FuzzySearchInput;
